import { render, staticRenderFns } from "./VerticalVideo.vue?vue&type=template&id=7df6651b&scoped=true&"
import script from "./VerticalVideo.vue?vue&type=script&lang=ts&"
export * from "./VerticalVideo.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalVideo.vue?vue&type=style&index=0&id=7df6651b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df6651b",
  null
  
)

export default component.exports